/* ==========================================================================
   eg-lymph-offer — Lymphatic Drainage Drops PDP, hero offer behaviour

   Gallery, accordions, ship date and the stock card are presentation. The offer
   is the part that matters: the chosen tier and the refill toggle drive every
   price in the block and the add-to-cart payload.
   ========================================================================== */
(function () {
  'use strict';

  var SHIP_OFFSET_DAYS = 2;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTHS_LONG = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function on(el, evt, fn) {
    if (el) el.addEventListener(evt, fn);
  }

  function init(root) {
    if (!root || root.dataset.lfoInit === 'true') return;
    root.dataset.lfoInit = 'true';

    shipDate(root);
    stickyBar(root);
    countdown(root);
    saleClock(root);
    stockBar(root);
    gallery(root);
    accordions(root);
    nutrition(root);
    carousel(root);
    tabs(root);
    faqs(root);
    offer(root);
  }

  /* ----------------------------------------------------------- sticky bar */

  // in the moment the offer's add-to-cart button itself has scrolled off the
  // top (not the whole CTA block under it), out again as soon as it is back
  function stickyBar(root) {
    var bar = root.querySelector('[data-lfo-sticky]');
    var anchor = root.querySelector('[data-lfo-atc]');
    if (!bar || !anchor) return;

    bar.removeAttribute('hidden');

    // room under the footer, so the bar never sits on its last lines
    function reserve() {
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }

    var ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom <= 0);
    }
    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () {
      reserve();
      request();
    });
    reserve();
    update();
  }

  /* ------------------------------------------------------------ ship date */

  function shipDate(root) {
    var el = root.querySelector('[data-lfo-ship-date]');
    if (!el) return;

    // the sale layout sets its own lead time and spells the month out
    var offset = parseInt(el.dataset.days, 10) || SHIP_OFFSET_DAYS;
    var months = el.dataset.format === 'long' ? MONTHS_LONG : MONTHS;

    var d = new Date();
    d.setDate(d.getDate() + offset);

    var day = d.getDate();
    var suffix = 'th';
    if (day % 10 === 1 && day !== 11) suffix = 'st';
    else if (day % 10 === 2 && day !== 12) suffix = 'nd';
    else if (day % 10 === 3 && day !== 13) suffix = 'rd';

    el.textContent = months[d.getMonth()] + ' ' + day + suffix;
  }

  /* ----------------------------------------------------------- sale clock */

  // the header's sale bar clock (eg-lymph-header.js): an hour per session
  // under the same key, so the two always show the same time
  function saleClock(root) {
    var h = root.querySelector('[data-lfo-sale-h]');
    var m = root.querySelector('[data-lfo-sale-m]');
    var s = root.querySelector('[data-lfo-sale-s]');
    if (!h || !m || !s) return;

    var TOTAL = 60 * 60 * 1000;
    var key = 'lfhSaleEnd';
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(key) || '0', 10);
    } catch (e) {
      /* storage blocked — the in-memory value is enough */
    }

    function reset() {
      end = Date.now() + TOTAL;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {
        /* noop */
      }
    }

    if (!end || end < Date.now()) reset();

    function tick() {
      // re-read: the header's clock may have rolled the hour over first
      try {
        var stored = parseInt(sessionStorage.getItem(key) || '0', 10);
        if (stored > end) end = stored;
      } catch (e) {
        /* noop */
      }
      var left = Math.max(0, end - Date.now());
      var sec = Math.floor(left / 1000);
      h.textContent = pad(Math.floor(sec / 3600));
      m.textContent = pad(Math.floor((sec % 3600) / 60));
      s.textContent = pad(sec % 60);
      if (left <= 0) reset();
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------ nutrition popup */

  function nutrition(root) {
    var dialog = root.querySelector('[data-lfo-nutri]');
    var open = root.querySelector('[data-lfo-nutri-open]');
    if (!dialog || !open || typeof dialog.showModal !== 'function') {
      if (open) open.hidden = true;
      return;
    }

    // fade out first, then close; Esc goes the same way (see `cancel` below)
    var closing = 0;
    function close() {
      if (!dialog.open || closing) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }
      dialog.classList.add('is-closing');
      closing = setTimeout(function () {
        closing = 0;
        dialog.classList.remove('is-closing');
        dialog.close();
      }, 200);
    }

    on(dialog, 'cancel', function (event) {
      event.preventDefault();
      close();
    });

    on(open, 'click', function () {
      dialog.showModal();
      document.documentElement.classList.add('lfo-locked');
    });
    on(dialog, 'close', function () {
      document.documentElement.classList.remove('lfo-locked');
    });
    on(root.querySelector('[data-lfo-nutri-close]'), 'click', close);

    // a click on the dimmed backdrop lands on the dialog itself, not the card
    on(dialog, 'click', function (event) {
      if (event.target === dialog) close();
    });

    // "Try Wellinda Risk-Free": back to the packs
    on(root.querySelector('[data-lfo-nutri-cta]'), 'click', function () {
      close();
      var tiers = root.querySelector('.lfo__tiers-title') || root.querySelector('.lfo__tiers');
      if (tiers) tiers.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ------------------------------------------------------ review carousel */

  // one review at a time; the arrows go round in a loop
  function carousel(root) {
    var box = root.querySelector('[data-lfo-carousel]');
    if (!box) return;
    var track = box.querySelector('[data-lfo-carousel-track]');
    var slides = box.querySelectorAll('[data-lfo-carousel-slide]');
    if (!track || slides.length < 2) return;

    function current() {
      var width = track.clientWidth;
      return width ? Math.round(track.scrollLeft / width) : 0;
    }

    function go(index) {
      var n = slides.length;
      index = ((index % n) + n) % n;
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    on(box.querySelector('[data-lfo-carousel-prev]'), 'click', function () {
      go(current() - 1);
    });
    on(box.querySelector('[data-lfo-carousel-next]'), 'click', function () {
      go(current() + 1);
    });
  }

  /* ----------------------------------------------------------------- tabs */

  function tabs(root) {
    var box = root.querySelector('[data-lfo-tabs]');
    if (!box) return;
    var list = box.querySelectorAll('[data-lfo-tab]');
    var panels = box.querySelectorAll('[data-lfo-panel]');

    function select(index, focus) {
      each(list, function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus) list[index].focus();
    }

    each(list, function (tab, i) {
      on(tab, 'click', function () {
        select(i, false);
      });
      // arrow keys move along the tab row, as a tablist should
      on(tab, 'keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        select((i + step + list.length) % list.length, true);
      });
    });
  }

  /* ----------------------------------------------------------------- FAQs */

  // one answer open at a time; a second click folds it again
  function faqs(root) {
    var items = root.querySelectorAll('[data-lfo-faq]');
    each(items, function (item) {
      var toggle = item.querySelector('[data-lfo-faq-toggle]');
      on(toggle, 'click', function () {
        var open = !item.classList.contains('is-open');
        each(items, function (other) {
          other.classList.remove('is-open');
          other.querySelector('[data-lfo-faq-toggle]').setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ------------------------------------------------------------ countdown */

  // a 14-hour window kept per session, so a reload does not restart it
  function countdown(root) {
    var el = root.querySelector('[data-lfo-countdown]');
    if (!el) return;

    var TOTAL = (13 * 3600 + 38 * 60 + 11) * 1000;
    var key = 'lfoStockEnd';
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(key) || '0', 10);
    } catch (e) {
      /* storage blocked — the in-memory value is enough */
    }

    function reset() {
      end = Date.now() + TOTAL;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {
        /* noop */
      }
    }

    if (!end || end < Date.now()) reset();

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (left <= 0) reset();
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ stock bar */

  /* The bar runs once, when it first scrolls into view. Checked on the frame,
     not on a timer: a timer that resets on every scroll event would only fire
     once the scrolling stopped. */
  function stockBar(root) {
    var fill = root.querySelector('[data-lfo-stock-fill]');
    if (!fill) return;

    var label = root.querySelector('[data-lfo-stock-percent]');
    var frame = 0;

    function visible() {
      var box = fill.getBoundingClientRect();
      return box.top < window.innerHeight && box.bottom > 0;
    }

    function start() {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (frame) cancelAnimationFrame(frame);
      fill.classList.add('is-filling');
      follow();
    }

    /* The figure beside the bar counts along with it. Rather than repeating the
       curve in script, the share is read back off the bar on every frame, so
       the number and the bar can never drift apart. */
    function follow() {
      if (!label) return;

      var track = fill.parentNode;
      var target = label.textContent;
      var running = true;

      // reduced motion leaves the bar unanimated: nothing to follow
      if (getComputedStyle(fill).animationName === 'none') return;

      function stop() {
        running = false;
        label.textContent = target;
      }

      fill.addEventListener('animationend', stop);
      // in case the animation never reports finishing
      setTimeout(stop, 2400);

      (function tick() {
        if (!running) return;
        var full = track.getBoundingClientRect().width;
        if (full) {
          var share = (fill.getBoundingClientRect().width / full) * 100;
          label.textContent = String(Math.round(share));
        }
        requestAnimationFrame(tick);
      })();
    }

    function check() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (visible()) start();
      });
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (visible()) start();
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* -------------------------------------------------------------- gallery */

  function gallery(root) {
    var track = root.querySelector('[data-lfo-track]');
    var slides = track ? track.querySelectorAll('[data-lfo-slide]') : [];
    var thumbs = root.querySelectorAll('[data-lfo-thumb]');
    var strip = root.querySelector('[data-lfo-thumbs]');
    if (!track || !slides.length || !thumbs.length) return;

    each(thumbs, function (thumb, i) {
      on(thumb, 'click', function () {
        if (slides[i]) {
          track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        }
      });
    });

    function sync() {
      var width = slides[0].getBoundingClientRect().width;
      var index = width > 0 ? Math.round(track.scrollLeft / width) : 0;
      index = Math.max(0, Math.min(index, thumbs.length - 1));

      each(thumbs, function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      // keep the active thumb inside the scrollable strip
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var t = thumbs[index];
        var left = t.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    on(track, 'scroll', sync);
    window.addEventListener('resize', sync);
    sync();
  }

  /* ----------------------------------------------------------- accordions */

  // each panel opens and folds on its own; the description starts open
  function accordions(root) {
    each(root.querySelectorAll('[data-lfo-acc]'), function (item) {
      var toggle = item.querySelector('[data-lfo-acc-toggle]');
      on(toggle, 'click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------------------------------------------------- offer / tiers / ATC */

  function offer(root) {
    var tiers = root.querySelectorAll('[data-lfo-tier]');
    var subscribeBox = root.querySelector('[data-lfo-subscribe]');
    var plans = root.querySelectorAll('[data-lfo-plan]');
    var frequency = root.querySelector('[data-lfo-frequency]');
    var atcPrice = root.querySelector('[data-lfo-atc-price]');
    var atcCompare = root.querySelector('[data-lfo-atc-compare]');
    var choice = root.querySelector('[data-lfo-choice]');
    var choiceText = root.querySelector('[data-lfo-choice-text]');
    var choiceTitle = root.querySelector('[data-lfo-choice-title]');

    var state = {
      tier: root.querySelector('[data-lfo-tier].is-selected') || tiers[0],
      subscribe: !!(subscribeBox && subscribeBox.checked)
    };

    /*
     * One toggle drives the whole block: with refills on, every tier shows its
     * selling-plan price and the subscription struck price; with it off, the
     * one-time product's price and its own struck price.
     */
    function render() {
      var tier = state.tier;
      if (!tier) return;
      var sub = state.subscribe;

      each(tiers, function (t) {
        var selected = t === tier;
        t.classList.toggle('is-selected', selected);
        t.setAttribute('aria-checked', String(selected));

        var price = t.querySelector('[data-lfo-tier-price]');
        var compare = t.querySelector('[data-lfo-tier-compare]');
        var save = t.querySelector('[data-lfo-tier-save]');
        var saved = Number(sub ? t.dataset.saveSubCents : t.dataset.saveOnceCents) > 0;

        if (price) price.textContent = sub ? t.dataset.priceSub : t.dataset.priceOnce;
        if (compare) {
          compare.textContent = sub ? t.dataset.compareSub : t.dataset.compareOnce;
          // no saving in this state means no compare-at: nothing to strike through
          compare.hidden = !saved;
        }
        if (save) {
          save.textContent = 'You save ' + (sub ? t.dataset.saveSub : t.dataset.saveOnce);
          save.hidden = !saved;
        }

        var unit = t.querySelector('[data-lfo-tier-unit]');
        if (unit) unit.textContent = sub ? t.dataset.unitSub : t.dataset.unitOnce;

        // % off follows the state too; no saving, no badge (nor its "+")
        var pct = Number(sub ? t.dataset.percentSub : t.dataset.percentOnce) || 0;
        var pctText = t.querySelector('[data-lfo-tier-pct]');
        if (pctText) pctText.textContent = pct;
        each(t.querySelectorAll('[data-lfo-tier-off]'), function (el) {
          el.hidden = pct <= 0;
        });
      });

      // Good Choice: the chosen pack's line, its saving in place of [save]
      if (choice && choiceText) {
        var line = tier.dataset.choice || '';
        var cents = Number(sub ? tier.dataset.saveSubCents : tier.dataset.saveOnceCents);
        var needsSave = line.indexOf('[save]') !== -1;
        var show = line !== '' && (!needsSave || cents > 0);
        if (show) {
          // the line is the merchant's rich text (bold allowed); the saving goes in as text
          var save = document.createElement('b');
          save.textContent = sub ? tier.dataset.saveSub : tier.dataset.saveOnce;
          choiceText.innerHTML = line.split('[save]').join(save.outerHTML);
          if (choiceTitle) choiceTitle.textContent = tier.dataset.choiceTitle || '';
        }
        choice.hidden = !show;
      }

      // plan cards (the test layout): the chosen one lit, the cadence that of
      // the chosen pack
      each(plans, function (plan) {
        var on = (plan.dataset.lfoPlan === 'sub') === sub;
        plan.classList.toggle('is-selected', on);
        plan.setAttribute('aria-checked', String(on));
      });
      if (frequency && tier.dataset.frequency) frequency.textContent = tier.dataset.frequency;

      if (atcPrice) atcPrice.textContent = sub ? tier.dataset.priceSub : tier.dataset.priceOnce;
      if (atcCompare) {
        var show = Number(sub ? tier.dataset.saveSubCents : tier.dataset.saveOnceCents) > 0;
        atcCompare.textContent = show ? (sub ? tier.dataset.compareSub : tier.dataset.compareOnce) : '';
      }
    }

    each(tiers, function (tier) {
      on(tier, 'click', function () {
        state.tier = tier;
        render();
      });
    });

    on(subscribeBox, 'change', function () {
      state.subscribe = subscribeBox.checked;
      render();
    });

    // the plan cards stand in for the checkbox: they set it and let it report
    each(plans, function (plan) {
      on(plan, 'click', function () {
        if (!subscribeBox) return;
        subscribeBox.checked = plan.dataset.lfoPlan === 'sub';
        subscribeBox.dispatchEvent(new Event('change'));
      });
    });

    render();
    addToCart(root, state);
  }

  function addToCart(root, state) {
    var button = root.querySelector('[data-lfo-atc]');
    var error = root.querySelector('[data-lfo-cart-error]');
    var addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var clearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
    var cartUrl = root.dataset.cartUrl || '/cart.js';
    var checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    var busy = false;

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    }

    function setBusy(on) {
      busy = on;
      if (on) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    /*
     * Shopify does not always answer with JSON: a bot check or an edge error
     * comes back as an HTML page, sometimes even with a 200. Parsing the body
     * ourselves keeps those from passing for a success.
     */
    function readJSON(res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = JSON.parse(text);
        } catch (e) {
          /* not JSON — handled below */
        }
        if (!res.ok || !data) {
          var err = new Error((data && (data.description || data.message)) || '');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(readJSON);
    }

    // best effort: a blocked /cart.js must not stop a cart that did fill
    function cartCount() {
      return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(readJSON)
        .then(function (cart) {
          return cart.item_count;
        })
        .catch(function () {
          return null;
        });
    }

    /*
     * One line: the chosen pack. The toggle picks the product as well as the
     * plan — a one-time purchase must never put the subscription variant in the
     * cart at its refill price.
     */
    function itemsFor(tier, subscribe) {
      if (!subscribe) {
        return [{ id: Number(tier.dataset.otpVariantId || tier.dataset.variantId), quantity: 1 }];
      }
      var item = { id: Number(tier.dataset.variantId), quantity: 1 };
      if (tier.dataset.sellingPlan) item.selling_plan = Number(tier.dataset.sellingPlan);
      return [item];
    }

    /*
     * With the page's cart drawer (eg-lymph-cart) the pack is added to the
     * cart as it stands, nothing cleared, and the drawer opens; it brings the
     * shipping insurance back in line with its toggle. Without the drawer the
     * cart only ever holds this one offer on its way to checkout, so it is
     * cleared first — a failed clear must not block the purchase, it only
     * risks a stale line.
     *
     * Checkout is reached only once the cart is known to hold something:
     * Shopify sends an empty cart from /checkout straight to the home page,
     * which is what a silently failed add looks like to the shopper.
     */
    on(button, 'click', function () {
      if (busy || !state.tier) return;

      var items = itemsFor(state.tier, state.subscribe);
      if (!items[0].id) {
        showError('This pack is unavailable right now. Please pick another one.');
        return;
      }

      showError('');
      setBusy(true);

      var drawer = window.lfcd && window.lfcd.afterAdd;
      var ready = drawer
        ? Promise.resolve()
        : postJSON(clearUrl).catch(function (err) {
            console.warn('[eg-lymph-offer] clear cart:', err);
          });

      ready
        .then(function () {
          return postJSON(addUrl, { items: items });
        })
        .then(cartCount)
        .then(function (count) {
          if (count === 0) throw new Error('');
          // the page's cart drawer is the step before checkout; without it,
          // straight on to checkout as before
          if (window.lfcd && window.lfcd.afterAdd) {
            setBusy(false);
            window.lfcd.afterAdd();
            return;
          }
          window.location.href = checkoutUrl;
        })
        .catch(function (err) {
          setBusy(false);
          showError(
            err.message ||
              'We could not add this to your cart. Please try again, or refresh the page.'
          );
          console.error('[eg-lymph-offer] add to cart:', err);
        });
    });

    // back from checkout the browser restores the page as it was left, loader
    // and all — wake the button up again
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) setBusy(false);
    });
  }

  /* ----------------------------------------------------------------- boot */

  function boot() {
    each(document.querySelectorAll('[data-lfo]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
